// Obtener la IP/localhost

const CONFIG = {
    //BASE_URL: `http://${localIP}:3000/`,     //IP automatica
    //API_URL: `http://${localIP}/tresatec/API`, //IP automatica

  //  BASE_URL: 'http://172.16.102.123:3000/',     //IP Polo
  //  API_URL: 'http://172.16.102.123/tresatec/API', //IP Polo

    //BASE_URL: 'http://192.168.1.16:3000/',  //IP ofi 32
    //API_URL: 'http://192.168.1.16/tresatecedutech/API', //IP ofi 32

    //BASE_URL: 'https://www.tresatec.com.ar/Demo/',  //demo Tresatec
    //API_URL: 'https://www.tresatec.com.ar/Demo/API',

    //BASE_URL: 'http://localhost:3000/',  //Localhost
    //API_URL: 'http://localhost/tresatecedutech/tresaedu-git/PLataforma-educativa--Tresatec-Demofinal/API',

   // BASE_URL: 'http://25.38.52.197:3000/',  //Localhost
   // API_URL: 'http://25.38.52.197/tresatec/Notificaciones%20en%20navegador/Plataforma-educativa--Tresatec-demo/API',

  //CON https
  BASE_URL: 'https://www.institutopetitdemeurville.com.ar/',  //Localhost
  API_URL: 'https://www.institutopetitdemeurville.com.ar/API'

  //  BASE_URL: 'http://192.168.1.49:3000',  //IP casa
  //  API_URL: 'http://192.168.1.49/tresatec/API', //IP casa
    
  };
  
export default CONFIG;

